export default __webpack_public_path__ + "static/media/chuck.332ae0e4.png";